<template>
  <div class="show__wrapper">
    <Modal
      v-model="openModal"
      :title="$t('generic.cancel_form_modal_title')"
      :subtitle="$t('generic.cancel_form_modal_subtitle')"
      :cta-text="$t('generic.cancel_form_modal_cta_text')"
      @confirm="leavePage"
      @cancel="cancelLeavePage">
    </Modal>

    <div class="show__heading">
      <div @click="cancelButtonHandler" class="show__back">
        <v-icon>mdi-chevron-left</v-icon>
      </div>
      <h1>{{ title }}</h1>
      <div class="ml-auto d-flex pl-4">
        <slot name="actions">
          <v-btn @click="cancelButtonHandler" class="ml-auto cancel__btn" color="primary" outlined>
            {{ $t("generic.buttons.cancel") }}
          </v-btn>
          <v-btn @click="saveButtonHandler" color="primary">
            {{ $t("generic.buttons.save") }}
          </v-btn>
        </slot>
      </div>
    </div>
    <slot></slot>
    <div class="show__bottom" v-if="showBottomActions">
      <div class="ml-auto d-flex pl-4">
        <slot name="actions">
          <v-btn @click="cancelButtonHandler" class="ml-auto cancel__btn" color="primary" outlined>
            {{ $t("generic.buttons.cancel") }}
          </v-btn>
          <v-btn @click="saveButtonHandler" color="primary">
            {{ $t("generic.buttons.save") }}
          </v-btn>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
  import resourceWrapper from "@/mixins/resourceWrapper";
  import Modal from "@/components/custom/Modal.vue";

  export default {
    name: "ResourceEditWrapper",
    components: {
      Modal,
    },
    mixins: [resourceWrapper],
    props: {
      showBottomActions: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
<style scoped lang="scss">
  @import "../../@core/preset/preset/typography/index.scss";
  @import "../../@core/preset/preset/functions";

  .show {
    &__wrapper {
      .show__back {
        margin-right: 15px;

        .v-icon {
          color: get-color("primary");
          height: 30px;
          width: 10px;
          font-size: 32px;
          cursor: pointer;
        }
      }
      .show__heading {
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        h1 {
          @include heading-2();
          color: get-color("headline");
        }
      }
      .show__bottom {
        margin-top: 24px;
        display: flex;
        align-items: center;
        h1 {
          @include heading-2();
          color: get-color("headline");
        }
      }
    }
  }

  .cancel__btn {
    margin-right: 16px;
  }
</style>
